<div class="container" [class.local]="true">
    <div class="logo" [class.no-shadow]="!shadow">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xml:space="preserve"
            [class.contrast]="contrast"
            viewBox="-60 0 240 50"
            class="logo-sag"
        >
            <g>
                <path
                    class="fil0"
                    d="M0,42l1.32-8.23q6.95,3.07,11.78,3.08a6,6,0,0,0,4.64-1.63A5,5,0,0,0,19,31.72a3.54,3.54,0,0,0-1.25-2.88,33.87,33.87,0,0,0-6.21-3.18Q7.9,24.07,6.39,23.27a17.63,17.63,0,0,1-2.76-1.78Q.06,18.67.06,13.38a13.94,13.94,0,0,1,2.34-8C4.81,1.79,8.75,0,14.25,0A41.2,41.2,0,0,1,27.18,2.33L25.35,10.2a55.4,55.4,0,0,0-6.2-2.12,18,18,0,0,0-4.33-.51A5.66,5.66,0,0,0,10.9,8.78a4.28,4.28,0,0,0-1.4,3.3,3.28,3.28,0,0,0,1.19,2.7,29.32,29.32,0,0,0,5.7,3q4.5,2,5.95,2.73a17.41,17.41,0,0,1,2.75,1.81q3.53,2.84,3.52,8.68,0,6.9-4.44,10.44-3.77,3-10.58,3A38.68,38.68,0,0,1,0,42Z"
                />
                <path
                    class="fil0"
                    d="M59,33.41H43.68L40.22,43.64H31.13L46.6.76h9.53l16,42.88H62.48Zm-2.4-7.26-3.21-9.26q-1-3.06-2.09-6.69c-.47,1.75-1.17,4-2.08,6.69l-3.15,9.26Z"
                />
                <path class="fil0" d="M77.3,43.64V.76h9.12V36.08h17.43v7.56Z" />
            </g>
        </svg>
    </div>
</div>
